import generateUuid from '../../utils/generateUuid';
import getFormEventData from '../../utils/getFormEventData';
import setFormSessionId from '../../utils/setFormSessionId';
import injectCAIWalletConfig from '../../utils/injectCAIWalletConfig';
import injectExtraInfo from '../../utils/injectExtraInfo';
import getSection from '../../utils/getSection';
import injectMyCars from '../../utils/injectMyCars';

export const DDC_FORM_ONPAGE = 'ddc.form.onPage';

function onPage(win, element) {
	const {
		DDC: {
			dataLayer = {},
			dataLayer: { vehicles },
			WidgetData: {
				'ws-tracking': {
					cookiesForExtraInfo,
					paramsForExtraInfo,
					localStorageForExtraInfo
				}
			}
		}
	} = win;

	let eventObject;
	const form = element.closest('form');

	setFormSessionId(form);

	if (form?.offsetParent) {
		if (form.getAttribute(DDC_FORM_ONPAGE) !== 'true') {
			form.setAttribute(DDC_FORM_ONPAGE, 'true');
			const formEventId = generateUuid(form);

			const eventData = {
				element,
				formEventId,
				trackingSection: getSection(element, win.DDC),
				...getFormEventData({
					form,
					vehicles,
					dataLayer
				})
			};

			eventObject = {
				eventType: DDC_FORM_ONPAGE,
				eventData
			};

			// injectCAIWalletConfig & injectExtraInfo are in events/form/submission.js as well
			// just in case the ws-tracking selectors do not find the form for onPage
			if (Object.keys(eventData.vehicle)) {
				injectCAIWalletConfig(win, form);
			}
			injectMyCars(form);
			injectExtraInfo(win, form, {
				cookiesForExtraInfo,
				paramsForExtraInfo,
				localStorageForExtraInfo
			});
		}
	}

	return eventObject;
}

export default onPage;
